import React from 'react';

export interface TableActionsProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'right';
}

/**
 * TableActions - A wrapper component for table action buttons (Edit, Delete, etc.)
 * 
 * Usage: Wrap action buttons with this component and add `group` class to the parent <tr>
 * The buttons remain visible for discoverability and gain emphasis on row hover.
 * 
 * Example:
 * ```tsx
 * <tr className="group hover:bg-primary-50 transition-colors">
 *   <td>...</td>
 *   <td>
 *     <TableActions>
 *       <Button variant="ghost" size="sm">Edit</Button>
 *       <Button variant="ghost" size="sm">Delete</Button>
 *     </TableActions>
 *   </td>
 * </tr>
 * ```
 */
export const TableActions: React.FC<TableActionsProps> = ({ children, className = '', align = 'left' }) => {
  return (
    <div className={`opacity-80 group-hover:opacity-100 transition-opacity duration-150 flex items-center gap-1.5 ${align === 'right' ? 'justify-end' : ''} ${className}`}>
      {children}
    </div>
  );
};

export default TableActions;
